/* lua.js generated code 0.3.0 */

GameGuideTrigger = table.const(table(
    [1, "kButtonShow", "buttonShow"],
    [1, "kEnterScene", "enterScene"],
    [1, "kExitScene", "exitScene"],
    [1, "kGameSecondSelectProp", "gameSecondSelectProp"],
    [1, "kGameCancelUseProp", "gameCancelUseProp"],
    [1, "kGameConfirmUseProp", "gameConfirmUseProp"],
    [1, "kGameFlag", "gameFlag"],
    [1, "kGameSwap", "gameSwap"],
    [1, "kGameUseProp", "gameUseProp"],
    [1, "kGameWaitingState", "gameWaitingState"],
    [1, "kGameFishSpawn", "fishSpawn"],
    [1, "kGameIceStageEnter", "iceStageEnter"],
    [1, "kPanelRise", "panelRise"],
    [1, "kPanelSink", "panelSink"],
    [1, "kPropBlock", "propBlock"]
))
